import React from 'react'
import LoaderHOC from '../shared/LayoutHOC'
const Page404 = () => {
    return (
        <div className="errorWrapper">
            <div className="errorIcon"></div>
            <div className="errorTitle">Bu sipariş numarası ile sipariş takibi yapılabilecek bir sipariş bulunamadı.</div>
            <div className="errorDesc">Hata olduğunu düşünüyorsan müşteri hizmetlerimiz ile iletişime geçebilirsin.</div>
            <div className="errorButton">
                <a href="/">YENİ SORGU YAP </a>
            </div>
        </div>
    )

}

export default LoaderHOC(Page404)
